module.exports = __webpack_public_path__ + "media/images/application/podcast/sound-wave-d2a2468b0c01d7e7fd57917bda1d47df.svg";